export { default as Employee } from './page';






// WEBPACK FOOTER //
// ./src/pages/Employee/index.js